import styled from '@emotion/styled';
import { Button } from '@presentation/components/Button';
import type { HeaderColor } from '../Header/types';

export const LocaleButton = styled(Button)<{ parentColor: HeaderColor }>`
  padding: 10px 15px;
  color: ${(props) =>
    props.parentColor === 'light' ? props.theme.color.dark.tint : props.theme.color.light.tint};
  border-color: ${(props) =>
    props.parentColor === 'light'
      ? props.theme.color.light.shade
      : props.theme.color.light.default};
  background: transparent !important;
`;
